import React from 'react';
import { BlockComponentProps } from 'client-react-block-renderer/src';

interface Props extends BlockComponentProps<Data, Config> { }

interface Config {
    mainHeaderText: string;
    customerSignUpButtonText: string;
    genericSignUpButtonText: string;
}

interface Data {
}

const BlockDontHaveAccountContainer = (props: Props) => {
    const checkingOut = window.location.href.includes('checking-out=true');
    return <div>
        <h1>{props.config.mainHeaderText}</h1>
        {checkingOut &&
            <a href="/secure/checkout/v1#/checkout/customer?checking-out=true" className="btn btn-primary" role="button">
                {props.config.customerSignUpButtonText}
            </a>
        }
        {!checkingOut &&
            <a href="/join-reliv" className="btn btn-primary" role="button">
                {props.config.genericSignUpButtonText}
            </a>
        }
    </div>;
};

export default BlockDontHaveAccountContainer;
